module.exports = __webpack_public_path__ + "img/Kappa Alpha Psi 1995.82baab5c.jpg";